
// ASSETS
import facilitiesLang from '../assets/lang/facilities.json';

export default {
  name: 'SPlaygroundMicrodatas',
  props: {
    playground: {
      type: Object,
      required: true,
    },
    playgroundPlaceName: {
      type: String,
      required: true,
    },
    playgroundPlaceAlias: {
      type: String,
      required: true,
    },
    playgroundAdminAlias: {
      type: String,
      required: true,
    },
    metaTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      facilitiesData: facilitiesLang.playground,
    };
  },
  computed: {
    playgroundMicrodatas() {
      const microdatas = {
        '@context': 'https://schema.org',
        '@type': 'Playground',
        name: this.metaTitle,
        url: `${process.env.VUE_APP_URL}${this.playgroundAdminAlias}/${this.playgroundPlaceAlias}/${this.playground.id}`,
        address: {
          '@type': 'PostalAddress',
          addressCountry: this.playground.country.id,
          addressRegion: this.playground?.admin ? this.playground.admin.name : this.playground.country.name,
          addressLocality: this.playgroundPlaceName,
          streetAddress: this.playground?.street,
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: this.playground.location.lat,
          longitude: this.playground.location.lon,
        },
      };

      if (this.playground.pictures[0]) {
        microdatas.image = `${process.env.VUE_APP_ASSETS_URL}playground/lg/${this.playground.pictures[0]}.webp`;
      }
      const playgroundFacilities = [];
      this.facilitiesData.forEach((facility) => {
        playgroundFacilities.push({
          '@type': 'PropertyValue',
          name: facility.label,
          value: this.playground.facilities[facility.id],
        });
      });
      if (playgroundFacilities.length > 0) {
        microdatas.additionalProperty = playgroundFacilities;
      }
      if (this.playground.description) {
        microdatas.description = this.playground.description;
      }
      if (this.playground.number_grade > 0) {
        microdatas.aggregateRating = {
          '@type': 'AggregateRating',
          ratingValue: this.playground.average_grade,
          reviewCount: this.playground.number_grade,
          itemReviewed: {
            '@type': 'Playground',
            name: this.metaTitle,
            url: `${process.env.VUE_APP_URL}${this.playgroundAdminAlias}/${this.playgroundPlaceAlias}/${this.playground.id}`,
            address: {
              '@type': 'PostalAddress',
              addressCountry: this.playground.country.id,
              addressRegion: this.playground?.admin ? this.playground.admin.name : this.playground.country.name,
              addressLocality: this.playgroundPlaceName,
              streetAddress: this.playground?.street,
            },
            geo: {
              '@type': 'GeoCoordinates',
              latitude: this.playground.location.lat,
              longitude: this.playground.location.lon,
            },
          },
        };
      }
      if (this.playground.schedules) {
        microdatas.openingHours = this.playground.schedules;
      }

      return microdatas;
    },
  },
};
